import styled from '@emotion/styled';
import {Backdrop as BackdropUI} from '@travel-frontend/ui-components';

export const Backdrop = styled(BackdropUI)`
  z-index: ${({theme}) => theme.stacking.zIndexExtra};
`;
